(function ($) {
	'use strict';

	$(function () {
		const $trigger = $('.js-not-found-asp');
		const $input = $('#js-search-trigger-main');

		$trigger.on('click', function () {
			window.scrollTo({
				top: 0,
				behavior: 'smooth'
			});

			$input.click();
		});
	});
})(jQuery);
